// Features/Sample-Button/Component.ts
import { fetchCart, openCart } from "Cart";
import { Composite } from "Composite";
var Selector_Cart_Icon = `.Sample-Button-Icon`;
var Selector_Cart_Text = `.Sample-Button-Text`;
var Selector_Status = `.Sample-Button-Text`;
var Selector_Piece = `popup-product-unique`;
var Selector_Plank = `popup-product-plank`;
var Selector_Popup = `#Sample-Popup`;

class Component extends Composite {
  parts;
  constructor() {
    super();
    const status = this.querySelector(Selector_Status);
    if (!status)
      throw `<sample-button> is missing status text element`;
    const popup = document.querySelector(Selector_Popup);
    if (!popup)
      throw `<sample-button> is missing `;
    this.parts = {
      status,
      popup,
      piece: popup.querySelector(Selector_Piece),
      plank: popup.querySelector(Selector_Plank),
      cart: {
        icon: this.querySelector(Selector_Cart_Icon),
        text: this.querySelector(Selector_Cart_Text)
      }
    };
    this.addEventListener("click", () => this.open());
  }
  get showPlank() {
    return this.dataset.showPlank === "true";
  }
  async open() {
    console.debug("Sample Button Click", {
      showPlank: this.showPlank
    });
    if (this.showPlank) {
      await this.prepare();
    } else {
      await this.prepareDirect();
    }
  }
  async prepare() {
    const { popup } = this.parts.popup;
    popup.loading = true;
    this.furnish();
    popup.open();
    await this.update();
    popup.loading = false;
  }
  async prepareDirect() {
    const cart = await fetchCart();
    if (!cart)
      return;
    const variantId = this.data.piece.variantId;
    const item = cart.items.find((item2) => item2.variant_id == variantId);
    const inCart = !!item;
    if (inCart) {
      openCart();
      return;
    }
    this.furnish();
    await this.update();
    await this.parts.piece.buy();
    this.dataset.inCart = String(true);
  }
  furnish() {
    const { productName, piece, plank } = this.data;
    this.parts.popup.popup.subtitle = productName;
    this.parts.piece.furnish({ ...piece, parent: this });
    this.parts.plank?.furnish({ ...plank, parent: this });
  }
  async update() {
    const cart = await fetchCart();
    if (!cart)
      return;
    this.updatePiece(cart);
    this.updatePlank(cart);
  }
  updatePiece(cart) {
    const variantId = this.data.piece.variantId;
    const item = cart.items.find((item2) => item2.variant_id == variantId);
    const inCart = !!item;
    this.parts.piece.update({
      disable: inCart
    });
  }
  updatePlank(cart) {
    const variantId = this.data.plank.variantId;
    const item = cart.items.find((item2) => item2.variant_id == variantId);
    const quantity = item?.quantity ?? 0;
    const capacity = Math.max(0, 12 - quantity);
    const atCapacity = capacity < 1;
    this.parts.plank?.update({
      disable: atCapacity,
      maximum: capacity
    });
  }
  onAddSuccess() {
    this.dataset.state = "Success";
    const text = this.parts.cart.text;
    text.innerHTML = this.data.messages.success;
    text.classList.remove("text-box");
    text.classList.add("text-check");
  }
  reset() {
    this.dataset.state = "Default";
    const text = this.parts.cart.text;
    text.innerHTML = this.data.messages.base;
    text.classList.remove("text-check");
    text.classList.add("text-box");
  }
  onAddFailure() {
    this.dataset.state = "Failure";
    const text = this.parts.cart.text;
    text.innerHTML = this.data.messages.failure;
  }
}

// Features/Sample-Button/mod.ts
customElements.define("sample-button", Component);
